<template>
	<div>
		<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="80px" class="demo-ruleForm">
			
			<el-form-item label="商品封面图:">
				<el-upload class="avatar-uploader" :action="this.$http_host + '/Admin/Upload/uploadImage'" :headers="headers" :show-file-list="false"
					:on-success="UploadSuccess"
					:before-upload="beforeUpload"
					:on-error="UploadError"
				>
				  <img v-if="ruleForm.banner" :src="this.$http_host + ruleForm.banner" class="avatar">
				  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
				</el-upload>
				<div>商品列表、商品详情封面，宽高：1:1.5</div>
			</el-form-item>
			
			<el-form-item label="首页:" prop="homes">
				<el-radio v-model="ruleForm.homes" :label="1">是</el-radio>
				<el-radio v-model="ruleForm.homes" :label="2">否</el-radio>
			</el-form-item>
			
			<el-form-item label="首页封面:" v-if="ruleForm.homes == 1">
				<el-upload class="avatar-uploader1" :action="this.$http_host + '/Admin/Upload/uploadImage'" :headers="headers" :show-file-list="false"
					:on-success="UploadSuccess1"
					:before-upload="beforeUpload"
					:on-error="UploadError"
				>
				  <img v-if="ruleForm.home_banner" :src="this.$http_host + ruleForm.home_banner" class="avatar1">
				  <i v-else class="el-icon-plus avatar-uploader-icon1"></i>
				</el-upload>
				<div>首页卡片封面尺寸，宽高：750x285</div>
			</el-form-item>
			
			<el-form-item label="首页标题:" prop="home_title"  v-if="ruleForm.homes == 1">
				<el-input size="small" v-model="ruleForm.home_title"></el-input>
			</el-form-item>
			
			<el-form-item label="类型:" prop="types">
				<el-radio v-model="ruleForm.types" :label="1">次卡礼盒</el-radio>
				<el-radio v-model="ruleForm.types" :label="2">普通商品</el-radio>
			</el-form-item>
			
			<el-form-item label="次数" prop="times" v-if="ruleForm.types == 1">
				<el-input type="number" size="small" v-model="ruleForm.times"></el-input>
			</el-form-item>
			
			
			
			<el-form-item label="商品标题:" prop="title">
				<el-input size="small" v-model="ruleForm.title"></el-input>
			</el-form-item>
			
			<el-form-item label="售价" prop="price">
				<el-input type="number" size="small" v-model="ruleForm.price"></el-input>
			</el-form-item>
			<el-form-item label="原价" prop="old_price">
				<el-input type="number" size="small" v-model="ruleForm.old_price"></el-input>
			</el-form-item>
				
			<el-form-item label="商品详情:" prop="goods_desc">
				<quill-editor ref="quillEditor" v-model="ruleForm.goods_desc" :options="editorOption"></quill-editor>
			</el-form-item>
			
			<el-form-item label="已售" prop="selled">
				<el-input type="number" size="small" v-model="ruleForm.selled"></el-input>
			</el-form-item>
			
			<el-form-item>
				<el-button type="danger" @click="submitForm('ruleForm')">修改并保存</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
	export default {
		props:['ruleForm'],
	    data() {
			return {
				editorOption: {
				  placeholder: '请输入内容...',
				  theme: 'snow',
				  modules: {
				    toolbar: {
				      container: [
				        ['bold', 'italic', 'underline', 'strike'],
				        ['blockquote', 'code-block'],
				        [{ header: 1 }, { header: 2 }],
				        [{ list: 'ordered' }, { list: 'bullet' }],
				        [{ script: 'sub' }, { script: 'super' }],
				        [{ indent: '-1' }, { indent: '+1' }],
				        [{ direction: 'rtl' }],
				        [{ size: ['small', false, 'large', 'huge'] }],
				        [{ header: [1, 2, 3, 4, 5, 6, false] }],
				        [{ color: [] }, { background: [] }],
				        [{ font: [] }],
				        [{ align: [] }],
				        ['clean'],
				        ['link', 'image', 'video']
				      ],
				      handlers: {
				        image: () => {
				          this.handleImageUpload()   // ✅ 调用 methods 里的函数
				        }
				      }
				    }
				  }
				},
				rules: {
					price: [{required: true, message: '请输入销售价格', trigger: 'blur'}],
					old_price: [{required: true, message: '请输入原价格', trigger: 'blur'}],
					title: [{required: true, message: '请输入商品标题', trigger: 'blur'}],
					goods_desc: [{required: true, message: '请输入商品详情描述', trigger: 'blur'}]
				},
				headers:{
					Authorization:'',
				}
	      };
	    },
		created() {
			this.headers.Authorization = localStorage.getItem('access_token');
		},
	    methods: {
			async handleImageUpload() {
			    const input = document.createElement('input')
			    input.type = 'file'
			    input.accept = 'image/*'
			    input.click()
			
			    input.onchange = async () => {
			      const file = input.files[0]
			      if (!file) return
			      const fd = new FormData()
			      fd.append('file', file)
			
			      // 走你封装的 http 请求
			      const res = await this.$api.post('/Upload/uploadImage', fd, {
			        headers: { 'Content-Type': 'multipart/form-data' }
			      })
			
			      if (res.code === 200) {
			        const quill = this.$refs.quillEditor.quill
			        const range = quill.getSelection()
			        quill.insertEmbed(range.index, 'image', this.$http_host + res.data.url)
			      } else {
			        this.$message.warning(res.msg || '上传失败')
			      }
			    }
			  },
			beforeUpload(file){
			},
			UploadSuccess(res, file, fileList){
				console.log(res);
				if(res.code == 200)
				{
					this.ruleForm.banner = res.data.url;
				}else{
					return this.$message({ message: res.msg, type: 'warning' });
				}
			},
			UploadSuccess1(res, file, fileList){
				if(res.code == 200)
				{
					this.ruleForm.home_banner = res.data.url;
				}else{
					return this.$message({ message: res.msg, type: 'warning' });
				}
			},
			UploadError(){
				return this.$message({ message: '上传失败，请重试', type: 'warning' });
			},
			submitApi(){
				let _this = this;
				const loading = this.$loading({
						lock: true,
						text: '编辑中',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
				_this.$api.post("/Goods/editGoods", this.ruleForm).then(res=>{
					loading.close();
					if(res.code == 200)
					{
						_this.$message({
							 message: '编辑成功~',
							 type: 'success',
						});
					}else{
						return _this.$message({
							 message: res.msg,
							 type: 'warning',
						});
					}
				}).catch(err=>{
					loading.close();
				});
			},
			submitForm(formName) {
				let _this = this;
				this.$refs[formName].validate((valid) => {
					if (valid) {
						_this.submitApi();
					} else {
						return _this.$message({
							 message: '提交失败',
							 type: 'warning',
						});
					}
				});
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
			}
	    }
	  }
</script>

<style scoped>
	.avatar-uploader .el-upload {
	    border: 1px dashed #d9d9d9;
	    border-radius: 6px;
	    cursor: pointer;
	    position: relative;
	    overflow: hidden;
	  }
	  .avatar-uploader .el-upload:hover {
	    border-color: #409EFF;
	  }
	  .avatar-uploader-icon {
	    font-size: 28px;
	    color: #8c939d;
	    min-width: 280px;
	    height: 200px;
	    line-height: 200px;
	    text-align: center;
		border: solid 1px #dcdcdc;
	  }
	  .avatar-uploader-icon1 {
	    font-size: 28px;
	    color: #8c939d;
	    width: 375px;
	    height: 143px;
	    line-height: 143px;
	    text-align: center;
	  		border: solid 1px #dcdcdc;
	  }
	  .avatar1 {
	    width: 375px;
	    height: 143px;
	    display: block;
	  }
	  .avatar {
	    min-width: 280px;
	    height: 200px;
	    display: block;
	  }
</style>